/** @jsx isolateComponent */

import { Button, Spacer, Text } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';

import { useSendFullStoryEvent, useTrackEvent } from '@zapier/toolbox-tracking';

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: 600,
    textAlign: 'center' as 'center',
  },
};

type Props = {
  eventName: string;
  fullStoryEventName: string;
  message: string;
};

export const Error = ({ eventName, fullStoryEventName, message }: Props) => {
  useSendFullStoryEvent(fullStoryEventName);
  useTrackEvent(eventName);

  return (
    <div css={styles.container}>
      <Text tag="h1" type="sectionHeader3">
        Something went wrong.
      </Text>

      <Spacer height={20} />

      <Text color="gray60" tag="p" type="paragraph3">
        {message}
      </Text>

      <Spacer height={30} />

      <Button hasShadow={true} href="/app/get-help" key="get-help">
        Get help
      </Button>
    </div>
  );
};
